// composables/dark.ts
import { ref, watchEffect, computed } from 'vue';

// 从本地存储或媒体查询获取暗色模式状态
export const isDark = ref(false);

// 初始化暗色模式状态
const initDarkMode = () => {
  // 先检查本地存储中是否有保存的偏好设置
  const savedMode = localStorage.getItem('dark-mode');
  if (savedMode) {
    isDark.value = savedMode === 'true';
    return;
  }

  // 再检查系统偏好
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  isDark.value = prefersDark;
};

// 监听系统偏好变化
watchEffect(() => {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  const handler = (event: MediaQueryListEvent) => {
    isDark.value = event.matches;
    localStorage.setItem('dark-mode', String(event.matches));
  };
  mediaQuery.addEventListener('change', handler);
  return () => mediaQuery.removeEventListener('change', handler);
});

// 初始化
initDarkMode();

//    自定义实现与使用
// // composables/dark.ts
// import { ref, watchEffect } from 'vue'
//
// export const isDark = ref(false)
//
// watchEffect(() => {
//   // 监听系统暗色模式变化
//   const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
//   isDark.value = mediaQuery.matches
//
//   // 响应系统模式变化
//   mediaQuery.addEventListener('change', (e) => {
//     isDark.value = e.matches
//   })
// })
